import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { prefetchRoute } from '@/hooks/use-prefetch';

interface PrefetchLinkProps extends LinkProps {
  children: React.ReactNode;
}

/**
 * A Link component that prefetches the route on hover/focus
 */
export function PrefetchLink({ to, children, onMouseEnter, onFocus, ...props }: PrefetchLinkProps) {
  const path = typeof to === 'string' ? to : to.pathname || '';

  const handleMouseEnter = (e: React.MouseEvent<HTMLAnchorElement>) => {
    prefetchRoute(path);
    onMouseEnter?.(e);
  };

  const handleFocus = (e: React.FocusEvent<HTMLAnchorElement>) => {
    prefetchRoute(path);
    onFocus?.(e);
  };

  return (
    <Link to={to} onMouseEnter={handleMouseEnter} onFocus={handleFocus} {...props}>
      {children}
    </Link>
  );
}
